import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tiposEnvio',
  templateUrl: './tiposEnvio.component.html',
  styleUrls: ['./tiposEnvio.component.scss']
})
export class TiposEnvioComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/tiposEnvio/tiposEnvio.component.ts